export default class RolesIndex {

    constructor() {
        this.bindEvents();
        //window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
        $("#roles_customSearch").on('keyup', (e) => {
            $('#roles-datatable').DataTable().search($(e.target).val()).draw();
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
    }
}